import * as actions from 'actions/HelpCentreActions/OrderIssueActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import { checkIfABExperimentRunning } from 'fk-cp-common-components/utils/orderUtils';
import get from 'lodash/get';
const { orderIssueActionsEnum } = actions;
const defaultState = {
    currentOrderItem: null,
    orderIssueItem: null,
    showViewMore: false,
    asyncStatus: INIT
};
export default function orderIssue(state = defaultState, action) {
    switch (action.type) {
        case orderIssueActionsEnum.GET_ORDER_ISSUES_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING
            });
        case orderIssueActionsEnum.GET_ORDER_ISSUES_SUCCESS:
            let data = action.data || {};
            return Object.assign({}, state, {
                issues: data.issues,
                predictedCount: data.predictedCount,
                orderIssueItem: action.orderIssueItem,
                showViewMore: checkIfABExperimentRunning(get(data.abResponse, ['experiments'], {}), 'issue_prediction'),
                asyncStatus: SUCCESS
            });
        case orderIssueActionsEnum.GET_ORDER_ISSUES_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR
            });
        case orderIssueActionsEnum.SET_CURRENT_ITEM:
            return Object.assign({}, state, {
                currentOrderItem: action.item
            });
        case orderIssueActionsEnum.RESET_ORDER_ISSUES:
            return Object.assign({}, state, {
                issues: [],
                orderIssueItem: null,
                asyncStatus: INIT
            });
        default:
            return state;
    }
}
